import { useLocation, useNavigate } from "react-router-dom";
import RFQActivityLog from "./RFQActivity";
import { FaArrowLeft } from "react-icons/fa";

const RFQLayout = ({ children, rfqId ,userDetails }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { mode = "add", formData } = location.state || {};
  const displayId = formData?.display_id;
  const isBuyer = userDetails?.company_type_id === 1;

  const getTitle = () => {
    if (mode === "edit") return "Edit RFQ";
    if (mode === "view") return "View RFQ";
    return "Create RFQ";
  };
  return (
    <RFQActivityLog rfqId={rfqId}>
      {(openActivity) => (
        <div>
          {/* Header */}
          <div className="rfq-header d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-start">
              <FaArrowLeft
                className="me-2 mt-1 cursor-pointer"
                onClick={() => navigate(-1)}
              />
              <div>
                <h3 className="mb-1">{getTitle()}</h3>
                {(mode === "edit" || mode === "view") && displayId && (
                  <h6 className="text-muted mb-0">{displayId}</h6>
                )}
              </div>
            </div>

            {rfqId && isBuyer &&(
              <button
  type="button"
  className="btn btn-outline-secondary"
  onClick={openActivity}
>
  Activity Log
</button>

            )}
          </div>

          {/* Form content */}
          <div>{children}</div>
        </div>
      )}
    </RFQActivityLog>
  );
};
export default RFQLayout;
